import { HttpContextToken } from '@angular/common/http';

export const IMPERSONATION_CONSTANTS = {
  IMPERSONATION_FLAG_KEY: 'isImpersonating',
  IMPERSONATION_HISTORY_ID: 'impersonationHistoryId',
  IMPERSONATION_HISTORY_END_DATE_PATH: '/ImpersonationEndDateTime',
  IMPERSONATION_SCOPES: 'impersonation sament:v3_entitlements:read_all',
  TARGET_USER_ID_KEY: 'targetUserId',
  IS_CONSULTANT_IMPERSONATION_KEY: 'isConsultantImpersonation'
} as const;

export enum ImpersonationStopReason {
  ApiError = 'apiError',
  Expired = 'expired',
  Logout = 'logout',
  UserInitiated = 'userInitiated',
  ValidationFailed = 'validationFailed'
}

export const SKIP_IMPERSONATION_LOG_METADATA = new HttpContextToken<boolean>(() => false);

export const CAPITAL_INSIGHT_IMPERSONATION_FEATURE_TOGGLE = 'capital-insight-with-impersonation-11376806';
